import {
    GET_POSITION_COMPETENCY_MAPPINGS,
    GET_POSITION_COMPETENCY_MAPPING_BY_ID,
    CREATE_POSITION_COMPETENCY_MAPPING,
    UPDATE_POSITION_COMPETENCY_MAPPING,
    DELETE_POSITION_COMPETENCY_MAPPING,
    DOWNLOAD_POSITION_COMPETENCY_MAPPING_TEMPLATE,
    UPLOAD_POSITION_COMPETENCY_MAPPING_FILE
} from "@/api/master-data/course-mapping/course-mapping";

const state = {
    positionCompetencyMappings: [],
    positionCompetencyMappingDetail: {},
    totalItems: 0,
    loading: false
};

const mutations = {
    SET_POSITION_COMPETENCY_MAPPINGS: (state, payload) => {
        state.positionCompetencyMappings = payload.data || [];
        state.totalItems = payload.totalItems || 0;
    },
    SET_LOADING: (state, payload) => {
        state.loading = payload;
    },
    SET_POSITION_COMPETENCY_MAPPING_DETAIL: (state, payload) => {
        state.positionCompetencyMappingDetail = payload;
    },
};

const getters = {
    getPositionCompetencyMappings: (state) => state.positionCompetencyMappings,
    getPositionCompetencyMappingDetail: (state) => state.positionCompetencyMappingDetail,
    getTotalItems: (state) => state.totalItems,
    getLoading: (state) => state.loading,
};

const actions = {
    getPositionCompetencyMappings: async ({ commit }, params) => {
        commit('SET_LOADING', true);
        try {
            const response = await GET_POSITION_COMPETENCY_MAPPINGS(params);
            if (response.data.httpCode === 200) {
                commit('SET_POSITION_COMPETENCY_MAPPINGS', response.data.data);
            } else {
                commit('SET_POSITION_COMPETENCY_MAPPINGS', { data: [], totalItems: 0 });
            }
        } catch (error) {
            console.error('Error fetching position competency mappings:', error);
            commit('SET_POSITION_COMPETENCY_MAPPINGS', { data: [], totalItems: 0 });
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    createPositionCompetencyMapping: async ({ commit }, data) => {
        commit('SET_LOADING', true);
        try {
            const response = await CREATE_POSITION_COMPETENCY_MAPPING(data);
            return response.data;
        } catch (error) {
            console.error('Error creating position competency mapping:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    updatePositionCompetencyMapping: async ({ commit }, { id, data }) => {
        commit('SET_LOADING', true);
        try {
            const response = await UPDATE_POSITION_COMPETENCY_MAPPING(id, data);
            return response.data;
        } catch (error) {
            console.error('Error updating position competency mapping:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    getPositionCompetencyMappingById: async ({ commit }, id) => {
        commit('SET_LOADING', true);
        try {
            const response = await GET_POSITION_COMPETENCY_MAPPING_BY_ID(id);
            if (response.data.httpCode === 200) {
                commit('SET_POSITION_COMPETENCY_MAPPING_DETAIL', response.data.data);
                return response.data.data;
            } else {
                commit('SET_POSITION_COMPETENCY_MAPPING_DETAIL', {});
                throw new Error('Failed to fetch position competency mapping details');
            }
        } catch (error) {
            console.error('Error fetching position competency mapping by ID:', error);
            commit('SET_POSITION_COMPETENCY_MAPPING_DETAIL', {});
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    deletePositionCompetencyMapping: async ({ commit }, id) => {
        commit('SET_LOADING', true);
        try {
            const response = await DELETE_POSITION_COMPETENCY_MAPPING(id);
            return response.data;
        } catch (error) {
            console.error('Error deleting position competency mapping:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    downloadPositionCompetencyMappingTemplate: async ({ commit }) => {
        commit('SET_LOADING', true);
        try {
            const response = await DOWNLOAD_POSITION_COMPETENCY_MAPPING_TEMPLATE();
            return response;
        } catch (error) {
            console.error('Error downloading position competency mapping template:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    uploadPositionCompetencyMappingFile: async ({ commit }, formData) => {
        commit('SET_LOADING', true);
        try {
            const response = await UPLOAD_POSITION_COMPETENCY_MAPPING_FILE(formData);
            return response.data;
        } catch (error) {
            console.error('Error uploading position competency mapping file:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    uploadBulkMapping: async ({ commit }, formData) => {
        commit('SET_LOADING', true);
        try {
            const response = await UPLOAD_POSITION_COMPETENCY_MAPPING_FILE(formData);
            return response.data;
        } catch (error) {
            console.error('Error uploading bulk mapping file:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};